module.exports = __webpack_public_path__ + "files/a6b350f0440a8920b74e0dbe0b9b0cea.png";